const META_STANDARD_EVENTS = new Set([
  "PageView",
  "ViewContent",
  "Search",
  "AddToCart",
  "InitiateCheckout",
  "AddPaymentInfo",
  "Purchase",
  "Lead",
  "CompleteRegistration",
  "Schedule",
  "Contact",
  "FindLocation",
  "Subscribe",
  "StartTrial",
]);

// Intent events stay custom on both Pixel and CAPI. Mapping a click to a
// completed standard event (Schedule/InitiateCheckout) overstates conversion
// quality and prevents Pixel/CAPI deduplication because the names differ.
const META_CAPI_CUSTOM_EVENTS = new Set([
  "reservation_clicked",
  "order_started",
]);

function normalizeMetaEventName(eventName: string) {
  if (eventName === "page_view") return "PageView";
  if (eventName === "lead_captured") return "Lead";
  if (eventName === "reservation_completed") return "Schedule";
  if (eventName === "checkout_started") return "InitiateCheckout";
  if (eventName === "order_completed") return "Purchase";
  if (eventName === "phone_clicked") return "Contact";
  if (eventName === "directions_clicked" || eventName === "map_clicked") return "FindLocation";
  // inquiry_submitted, contact_form_submitted and subscribe_success always fire
  // alongside lead_captured, which is the one Lead. Mapping them too sent a second
  // CAPI Lead with its own event ID that the Pixel never matched, so every form
  // counted twice. incentive_popup_submitted has no lead_captured partner.
  if (eventName === "incentive_popup_submitted") return "Lead";
  if (eventName === "external_order_exit_completed") {
    return "InitiateCheckout";
  }
  if (eventName === "giveaway_viewed") return "ViewContent";

  return eventName;
}

export function getMetaCapiEventName(eventName: string) {
  const metaEventName = normalizeMetaEventName(eventName);
  if (META_STANDARD_EVENTS.has(metaEventName)) return metaEventName;
  if (META_CAPI_CUSTOM_EVENTS.has(metaEventName)) return metaEventName;
  return undefined;
}
